<script>
	import ToolbarNewButton from './ToolbarNewButton.svelte';
</script>

<div class="proteus-toolbar-item is-full">
	<ToolbarNewButton />
</div>
